import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import CurrencyInput from "react-currency-input-field";
import { formatValue } from "react-currency-input-field";
import { makeStyles } from "@material-ui/core/styles";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import * as XLSX from "xlsx";
import { renglonesReporteMeli } from "./reporteMeli";
import { leerExcelNumerosLargos } from "./leerExcelNumerosLargos";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function VentaDirectaArchivoCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const AREAS_APARTADO = process.env.REACT_APP_AREAS_APARTADO;
  const AREAS_MELI = process.env.REACT_APP_AREAS_MELI;
  const AREAS_MELI_NOVA = process.env.REACT_APP_AREAS_MELI_NOVA;
  const AREAS_AMAZON = process.env.REACT_APP_AREAS_AMAZON;
  const AREAS_AMAZON_YOU = process.env.REACT_APP_AREAS_AMAZON_YOU;
  const AREAS_WALMART = process.env.REACT_APP_AREAS_WALMART;
  const AREAS_WALMART_NOVA = process.env.REACT_APP_AREAS_WALMART_NOVA;
  const AREAS_WALMART_DROP = process.env.REACT_APP_AREAS_WALMART_DROP;
  const AREAS_WALMART_NOVA_DROP = process.env.REACT_APP_AREAS_WALMART_NOVA_DROP;
  const AREAS_COPPEL = process.env.REACT_APP_AREAS_COPPEL;
  const AREAS_COPPEL_NOVA = process.env.REACT_APP_AREAS_COPPEL_NOVA;
  const AREAS_COPPEL_DROP = process.env.REACT_APP_AREAS_COPPEL_DROP;
  const AREAS_COPPEL_NOVA_DROP = process.env.REACT_APP_AREAS_COPPEL_NOVA_DROP;
  const AREAS_TIKTOK = process.env.REACT_APP_AREAS_TIKTOK;
  const PASSWORD_CAMBIA_PRECIO = process.env.REACT_APP_PASSWORD_CAMBIA_PRECIO;
  const URL_SEND_MAIL = process.env.REACT_APP_URL_SEND_MAIL;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_SUCURSALES = process.env.REACT_APP_URL_SUCURSALES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  // const [idsArticulos, setIdsArticulos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [sucursales, setSucursales] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);
  const [sucursal, setSucursal] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedColaboradorName, setSelectedColaboradorName] = useState("");
  const [value, setValue] = useState("");
  const [articulosUnicos, setArticulosUnicos] = useState([]);
  const [articulosCatalogo, setArticulosCatalogo] = useState([]);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [inventarios, setInventarios] = useState([]);

  const [cliente, setCliente] = useState("");
  const [condPago, setCondPago] = useState("Contado");
  const [departamentoCliente, setDepartamentoCliente] = useState("");
  const [paqueterias, setPaqueterias] = useState([]);
  const [paqueteria, setPaqueteria] = useState("NA");
  const [idPaqueteria, setIdPaqueteria] = useState("650b273bc9855e3f883e8f5d");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(AREAS_MELI);
  const [selectedAreaName, setSelectedAreaName] = useState("Mercado Libre");
  // Almacen del que salen los renglones que NO son Full (se quedan como Pedido)
  const [selectedAreaPedidos, setSelectedAreaPedidos] = useState(AREAS_CEDIS);
  const [selectedAreaPedidosName, setSelectedAreaPedidosName] = useState("Cedis Toluca");
  const [inventariosPedidos, setInventariosPedidos] = useState([]);
  const [comisionTDC, setComisionTDC] = useState(0);
  const [comisionFlete, setComisionFlete] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);
  const [total_cajas, setTotalCajas] = useState(0);
  const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  // const [descuento, setDescuento] = useState(0);
  // const [descuentoNumero, setDescuentoNumero] = useState(0);

  const [listaPrecios, setListaPrecios] = useState(1);

  const [bancos, setBancos] = useState([]);
  const [codigoAgrupado, setCodigoAgrupado] = useState(uuidv4());

  const [pago, setPago] = useState();
  const [efectivo, setEfectivo] = useState(0);
  const [tdc, setTDC] = useState(0);
  const [transfer, setTransfer] = useState(0);
  const [fechaTransfer, setFechaTransfer] = useState("NA");
  const [referencia, setReferencia] = useState("NA");
  const [destino, setDestino] = useState("NA");
  const [terminal, setTerminal] = useState("Tarjeta");
  const [saldo, setSaldo] = useState(0);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [cambiarPrecio, setCambiarPrecio] = useState(false);

  const [modalCambiaPrecio, setModalCambiaPrecio] = useState(false);
  const toggleCambiaPrecio = () => setModalCambiaPrecio(!modalCambiaPrecio);

  // TikTok: el reporte no trae el SKU del vendedor, solo el ID de TikTok. Los ID
  // que todavia no estan ligados a un articulo se ligan aqui una sola vez.
  const [tiktokPendiente, setTiktokPendiente] = useState(null); // { filas, sinLigar: [...] }
  const [guardandoTikTok, setGuardandoTikTok] = useState(false);
  const [password, setPassword] = useState("");

  const [mailAutEnviado, setMailAutEnviado] = useState(false);
  const [randomCambiaPrecio, setRandomCambiaPrecio] = useState(
    (Math.random() + 1).toString(36).substring(2)
  );

  useMemo(() => {
    axios
      .get(`${URL_ARTICULOS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulosCat = res.data;
        setArticulosCatalogo(allArticulosCat);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_PAQUETERIAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allPaqueterias = res.data;
    //     setPaqueterias(allPaqueterias);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    if (selectedArea) {
      axios
        .get(`${URL_INVENTARIOS}AcumuladoAlmacenVD/${selectedArea}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allDisponible = response.data;
          setInventarios(allDisponible);

          setArticulos(allDisponible);
          // let result = allDisponible.map((a) => a.idArticulo);
          // setIdsArticulos(result);

          let unicos = allDisponible.filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.idArticulo === value.idArticulo)
          );
          setArticulosUnicos(unicos);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    // Inventario del almacen que surte los renglones que NO son Full
    if (selectedAreaPedidos) {
      axios
        .get(`${URL_INVENTARIOS}AcumuladoAlmacenVD/${selectedAreaPedidos}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          setInventariosPedidos(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });

    // if(selectedCliente == "650a334ab99f0b3555a8cf16"){
    //   axios
    //   .get(`${URL_CLIENTES}/${selectedCliente}`, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allCliente = res.data;
    //     setCliente(allCliente);
    //     // setDescuento(allCliente.descuento);
    //     setListaPrecios(allCliente.listaPrecios);
    //     setSelectedColaborador(allCliente.vendedor[0]._id);
    //     setSelectedColaboradorName(allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido);
    //     setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
    //     setCondPago(allCliente.forma_pago);
    //     if(allCliente.forma_pago == "Credito"){
    //       setPago(false)
    //     }else setPago(true)
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    // }
  }, [selectedArea, selectedAreaPedidos]);


  // ===== Inventario del master =====
  // El master no tiene inventario propio. Si una variante no alcanza en el almacen, al guardar se
  // convierten unidades de otras variantes del mismo master (POST inventariosConvertirDesdeMaster,
  // queda como Ajuste de Inventario) y despues se vende normal.
  const infoArticulo = useMemo(
    () => new Map(articulosCatalogo.map((a) => [String(a._id), a])),
    [articulosCatalogo]
  );
  // Articulos (no masters) sin registro en el almacen entran con 0 para poder importarlos:
  // la venta puede sobregirar y el back crea el registro en negativo
  const conVirtuales = (lista) => {
    const ids = new Set(lista.map((i) => String(i.idArticulo)));
    const skus = new Set(lista.map((i) => String(i.SKU || "").toUpperCase()));
    const virtuales = articulosCatalogo
      .filter(
        (a) =>
          a.modelo !== "MASTER" &&
          a.is_active !== "No" &&
          !ids.has(String(a._id)) &&
          !skus.has(String(a.SKU || "").toUpperCase())
      )
      .map((a) => ({
        _id: "",
        idArticulo: a._id,
        SKU: a.SKU,
        codigo: a.SKU,
        ASIN: a.ASIN,
        codigoOrigen: a.codigo,
        nombre: a.nombre,
        cantidad: 0,
        venta: a.venta,
        costoMX: a.costoMX,
        costoUnitario: a.costoMX,
        piezasPorCaja: a.piezasPorCaja,
        virtual: true,
      }));
    return [...lista, ...virtuales];
  };
  const inventariosVenta = useMemo(() => conVirtuales(inventarios), [inventarios, articulosCatalogo]);
  // Tambien se reconoce el SKU de origen (campo codigo) de articulos que se renombraron al SKU del
  // layout: p. ej. las chamarras, que en Mercado Libre siguen publicadas como MC-ROP-UNI-*
  const conCodigoOrigen = (mapa, lista) => {
    lista.forEach((i) => {
      const c = String(i.codigoOrigen || "").trim();
      if (c && !mapa[c]) mapa[c] = i;
    });
    return mapa;
  };
  const inventariosPedidosVenta = useMemo(
    () => conVirtuales(inventariosPedidos),
    [inventariosPedidos, articulosCatalogo]
  );

  // Que renglones Full se cubren con el master (mismo calculo que el back: conversiones exactas,
  // de la presentacion mas chica a la mas grande). grupos: [{ articulo, total, cantInv, SKU }]
  const planMaster = (grupos) => {
    const libre = new Map();
    inventarios.forEach((i) =>
      libre.set(String(i.idArticulo), (libre.get(String(i.idArticulo)) || 0) + (Number(i.cantidad) || 0))
    );
    // lo que se vende de cada articulo en este archivo no se puede convertir
    grupos.forEach((g) => libre.set(String(g.articulo), (libre.get(String(g.articulo)) || 0) - g.total));
    const conversiones = [];
    const sinCubrir = [];
    for (const g of grupos) {
      const falta = g.total - g.cantInv;
      if (falta <= 0) continue;
      const v = infoArticulo.get(String(g.articulo));
      if (!v || !v.articuloPadre) {
        sinCubrir.push(g);
        continue;
      }
      const fV = Number(v.piezasPorCaja) || 1;
      const fuentes = articulosCatalogo
        .filter(
          (h) =>
            String(h.articuloPadre) === String(v.articuloPadre) &&
            String(h._id) !== String(v._id) &&
            h.is_active !== "No"
        )
        .map((h) => ({ id: String(h._id), f: Number(h.piezasPorCaja) || 1 }))
        .filter(
          (x) =>
            x.f <= fV &&
            Math.abs(fV / x.f - Math.round(fV / x.f)) < 1e-9 &&
            (libre.get(x.id) || 0) > 0
        )
        .sort((a, b) => a.f - b.f);
      let porCubrir = falta * fV;
      const usos = [];
      for (const x of fuentes) {
        if (porCubrir <= 1e-9) break;
        const u = Math.min(libre.get(x.id), Math.floor(porCubrir / x.f + 1e-9));
        if (u > 0) {
          usos.push([x.id, u]);
          porCubrir -= u * x.f;
        }
      }
      if (porCubrir > 1e-9) {
        sinCubrir.push(g);
        continue;
      }
      usos.forEach(([id, u]) => libre.set(id, libre.get(id) - u));
      conversiones.push({ ...g, falta });
    }
    return { conversiones, sinCubrir };
  };

  // Un mismo articulo puede venir en los dos grupos y cada grupo sale de un
  // almacen distinto, por eso la llave incluye Full/Pedido
  // TikTok nunca se surte al guardar: con cliente TikTok TODO renglon (de cualquier archivo o capturado a
  // mano) es pedido pendiente en CEDIS y se surte en Pendiente Surtir
  const clienteTikTok =
    !!cliente &&
    (String(cliente.codigo || "").trim().toUpperCase() === "TIKTOK" ||
      (cliente.areas || []).some((a) => String((a && a._id) || a) === AREAS_TIKTOK));
  const esFullRenglon = (a) => !clienteTikTok && a.esFull !== false;
  const claveGrupo = (a) => `${a.articulos}|${esFullRenglon(a) ? "F" : "P"}`;

  const cantidadesAgrupadas = {};
inputFields.forEach((a) => {
  const id = claveGrupo(a);
  if (!cantidadesAgrupadas[id]) {
    cantidadesAgrupadas[id] = {
      totalCantidad: 0,
      cantInv: parseFloat(a.cantInv),
    };
  }
  cantidadesAgrupadas[id].totalCantidad += parseFloat(a.cantidad);
});

// Solo los renglones Full descuentan inventario al guardar; los que se quedan
// como Pedido estan pendientes de surtir, asi que no se marcan como excedidos.
const planTabla = planMaster(
  Object.entries(cantidadesAgrupadas)
    .filter(([id]) => id.endsWith("|F"))
    .map(([id, val]) => ({ articulo: id.split("|")[0], total: val.totalCantidad, cantInv: val.cantInv || 0 }))
);
const articulosExcedidos = new Set(planTabla.sinCubrir.map((g) => `${g.articulo}|F`));
const articulosDelMaster = new Set(planTabla.conversiones.map((g) => `${g.articulo}|F`));


const headersAuth = {
  headers: {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  },
};

// Pedido de TikTok: si sus renglones ya traen el estado de cuenta (comisiones). "" si no es de TikTok
const edoCtaTikTokPedido = (renglones) => {
  const tt = renglones.filter((a) => String(a.refMarketplace || "").startsWith("TT|"));
  if (!tt.length) return "";
  const si = tt.filter((a) => a.edoCtaTikTok === "Si").length;
  return si === tt.length ? "Aplicado" : si ? "Parcial" : "Pendiente";
};

// Crea un Pedido con sus articulos.
//   esVenta = true  -> venta directa: genera Surtido + ArticulosSurtidos y descuenta inventario
//   esVenta = false -> queda como Pedido pendiente de surtir (no toca inventario)
const crearPedidoDesdeRenglones = async (renglones, area, esVenta, opts = {}) => {
  const usarTotalesGlobales = opts.usarTotalesGlobales === true;
  const conComisiones = opts.conComisiones === true;

  let totCantidad;
  let sub;
  let ivaGrupo;
  let totalGrupo;
  let saldoGrupo;

  if (usarTotalesGlobales) {
    // Un solo grupo: se respetan tal cual los totales que ya calculo la vista
    totCantidad = total_cantidad;
    sub = parseFloat(subTotal);
    ivaGrupo = parseFloat(iva);
    totalGrupo = parseFloat(total_general);
    saldoGrupo = parseFloat(saldo);
  } else {
    totCantidad = renglones.reduce((t, a) => t + parseFloat(a.cantidad), 0);
    sub = renglones.reduce((t, a) => t + parseFloat(a.total), 0);
    ivaGrupo = selectedImpuesto != 0 ? (selectedImpuesto * sub) / 100 : 0;
    const descGrupo = (sub * descuento) / 100;
    totalGrupo =
      sub +
      ivaGrupo -
      descGrupo +
      (conComisiones ? parseFloat(comisionTDC) + parseFloat(comisionFlete) : 0);
    saldoGrupo = conComisiones
      ? totalGrupo - efectivo - tdc - transfer
      : totalGrupo;
  }

  const { data: dataPedido } = await axios.post(
    URL_PEDIDOS,
    {
      fecha,
      clientes: selectedCliente,
      departamentosClientes: departamentoCliente,
      colaboradores: selectedColaborador,
      total_general: parseFloat(totalGrupo).toFixed(2),
      observaciones: esVenta
        ? observaciones
        : renglones.every((a) => String(a.refMarketplace || "").startsWith("TT|"))
        ? `${observaciones} / TikTok - pendiente de surtir`
        : `${observaciones} / No Full - pendiente de surtir`,
      total_cantidad: totCantidad,
      paqueterias: "665e148c225a1c1e3f506999",
      areas: area,
      sucursales: sucursal,
      comisionTDC: conComisiones ? comisionTDC : 0,
      comisionFlete: conComisiones ? comisionFlete : 0,
      subTotal: parseFloat(sub).toFixed(2),
      iva: parseFloat(ivaGrupo).toFixed(2),
      impuestos: selectedImpuesto,
      surtido: esVenta ? "Si" : "No",
      autorizadoApartado: "Si",
      autorizadoSurtido: "Si",
      editado: "No",
      fechaModificado: fecha,
      creado: user.id,
      fecha_estimada: fecha,
      fecha_entrega: fecha,
      entregaInsumos: "No",
      edoCtaTikTok: edoCtaTikTokPedido(renglones),
    },
    headersAuth
  );

  let dataSurtido = null;
  if (esVenta) {
    const respSurtido = await axios.post(
      URL_SURTIDOS,
      {
        fecha,
        pedidos: dataPedido._id,
        observaciones,
        user: user.id,
        clientes: selectedCliente,
        areas: area,
        total_general: parseFloat(totalGrupo).toFixed(2),
        saldo: parseFloat(saldoGrupo).toFixed(2),
        subTotal: parseFloat(sub).toFixed(2),
        iva: parseFloat(ivaGrupo).toFixed(2),
        impuestos: selectedImpuesto,
        is_active: "Si",
        entregado: "Si",
        paqueterias: "665e148c225a1c1e3f506999",
        colaboradores: selectedColaborador,
        comisionPagada: "No",
      },
      headersAuth
    );
    dataSurtido = respSurtido.data;
  }

  for (const a of renglones) {
    const { data: dataArtPed } = await axios.post(
      URL_ARTICULOS_PEDIDO,
      {
        pedidos: dataPedido._id,
        articulos: a.articulos,
        cantidad: parseFloat(a.cantidad),
        cantidadProcesos: 0,
        // Nace pendiente; en la venta, /articulosSurtidos/ventaDirecta lo pasa a surtido (si aqui ya
        // naciera surtido se contaria dos veces: surtido 2x y pendiente negativo)
        pendiente_surtir: parseFloat(a.cantidad),
        surtido: 0,
        precio: parseFloat(a.precio).toFixed(2),
        precioBruto: parseFloat(a.precioBruto).toFixed(2),
        total: parseFloat(a.total).toFixed(2),
        cliente: "NA",
        refMarketplace: a.refMarketplace || "",
        edoCtaTikTok: a.edoCtaTikTok || "",
        fechaEdoCtaTikTok: a.edoCtaTikTok === "Si" ? fecha : "",
        autorizadoApartado: "Si",
        autorizadoSurtido: "Si",
        porcentajeComision: a.porcentajeComision,
        comision: a.comision,
        costoFijo: a.costoFijo,
        envio: a.envio,
        retencionISR: a.retencionISR,
        retencionIVA: a.retencionIVA,
        precioBrutoSinIVA: a.precioBrutoSinIVA,
      },
      headersAuth
    );

    // Solo la venta directa descuenta inventario
    if (esVenta) {
      await axios.post(
        `${URL_ARTICULOS_SURTIDOS}/ventaDirecta`,
        {
          fecha,
          surtidos: dataSurtido._id,
          inventarios: a.idInv,
          cantidad: parseFloat(a.cantidad),
          articulos: a.articulos,
          pedidos: dataPedido._id,
          articulosPedido: dataArtPed._id,
          costoUnitario: a.costoUnitario,
          clientes: selectedCliente,
          areas: area,
          precio: parseFloat(a.precio).toFixed(2),
          precioBruto: parseFloat(a.precioBruto).toFixed(2),
          paqueterias: "665e148c225a1c1e3f506999",
          porEntregar: 0,
          entregadoCantidad: a.cantidad,
          entregado: "Si",

          porcentajeComision: a.porcentajeComision,
          comision: a.comision,
          costoFijo: a.costoFijo,
          envio: a.envio,
          retencionISR: a.retencionISR,
          retencionIVA: a.retencionIVA,
          precioBrutoSinIVA: a.precioBrutoSinIVA,
        },
        headersAuth
      );
    }
  }

  return dataPedido;
};

const savePedido = async (event) => {
  event.preventDefault();

  const conCantidad = (a) => a.articulos && parseFloat(a.cantidad) > 0;
  // Columna AO del reporte MeLi: Full se vende, lo demas se queda como Pedido
  const renglonesFull = inputFields.filter((a) => conCantidad(a) && esFullRenglon(a));
  const renglonesPedido = inputFields.filter((a) => conCantidad(a) && !esFullRenglon(a));

  if (renglonesFull.length === 0 && renglonesPedido.length === 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "No hay articulos con cantidad para guardar",
    });
    return;
  }

  // No registrar dos veces el mismo pedido del marketplace (p. ej. si vuelven a subir el mismo
  // reporte otro dia): los renglones ya registrados se quitan de la captura y se pide revisar
  const refs = [...renglonesFull, ...renglonesPedido].map((a) => a.refMarketplace).filter(Boolean);
  if (refs.length) {
    let existentes = [];
    try {
      const { data } = await axios.post(`${URL_ARTICULOS_PEDIDO}RefsMarketplace`, { refs }, headersAuth);
      existentes = data.existentes || [];
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo revisar si esos pedidos del marketplace ya estaban registrados",
        footer: `${error.response?.data?.message || error.message || ""}`,
      });
      return;
    }
    if (existentes.length) {
      const ya = new Set(existentes.map((e) => e.ref));
      let quitados = 0;
      for (let i = inputFields.length - 1; i >= 0; i--) {
        if (ya.has(inputFields[i].refMarketplace)) {
          inputFields.splice(i, 1);
          quitados++;
        }
      }
      setInputFields([...inputFields]);
      ActualizaTotales();
      const nombreRef = (r) => {
        const [mp, pedidoMP] = r.split("|");
        return `${mp === "TT" ? "TikTok" : "MeLi"} #${pedidoMP}`;
      };
      const detalle = [...new Map(existentes.map((e) => [e.ref, e])).values()]
        .slice(0, 20)
        .map((e) => `${nombreRef(e.ref)} → ya está en el pedido ${e.idPedido} (${e.fecha})`)
        .join("<br>");
      Swal.fire({
        icon: "warning",
        title: "Pedidos ya registrados",
        html:
          `${quitados} renglón(es) ya se habían registrado en otra venta y se quitaron de la captura para no duplicarlos:` +
          `<p style="text-align:left;margin-top:10px">${detalle}${existentes.length > 20 ? "<br>..." : ""}</p>` +
          "Revisa los totales y vuelve a guardar." +
          (existentes.some((e) => e.ref.startsWith("TT|"))
            ? "<br><br>Si es el estado de cuenta de TikTok de pedidos ya registrados, súbelo en el listado de Pedidos (botón <b>Estado de cuenta TikTok</b>) para descontarles las comisiones."
            : ""),
      });
      return;
    }
  }

  // Solo los renglones Full descuentan inventario, asi que solo esos se validan
  const cantidadesAgrupadasFull = {};
  renglonesFull.forEach((a) => {
    const id = a.articulos;
    if (!cantidadesAgrupadasFull[id]) {
      cantidadesAgrupadasFull[id] = {
        totalCantidad: 0,
        cantInv: parseFloat(a.cantInv),
        SKU: a.SKU || a.articulosNombre || "SKU no definido",
      };
    }
    cantidadesAgrupadasFull[id].totalCantidad += parseFloat(a.cantidad);
  });

  const planFull = planMaster(
    Object.entries(cantidadesAgrupadasFull).map(([id, v]) => ({
      articulo: id,
      total: v.totalCantidad,
      cantInv: v.cantInv || 0,
      SKU: v.SKU,
    }))
  );
  // Ya no se bloquea: lo que no alcanza (ni con el master) se vende y el inventario queda en
  // negativo; se avisa al final para hacer el ajuste
  const enNegativo = planFull.sinCubrir.map(
    (g) => `${g.SKU}: ${g.cantInv} - ${g.total} = ${Number((g.cantInv - g.total).toFixed(2))}`
  );

  // Validar precios > 0
  const preciosInvalidos = inputFields.filter((a) => parseFloat(a.precio) <= 0);
  if (preciosInvalidos.length > 0) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Hay artículos con precio menor o igual a 0. Verifica antes de guardar.",
    });
    return;
  }

  if (renglonesPedido.length > 0 && !selectedAreaPedidos) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Selecciona el almacen del que salen los renglones que no son Full",
    });
    return;
  }

  if (selectedCliente != "" && selectedArea != "") {
    setValidaBoton(false);
    toggleProgreso();

    // Con un solo grupo se conservan los totales que ya calculo la vista
    const grupoUnico = renglonesFull.length === 0 || renglonesPedido.length === 0;

    try {
      const creados = [];

      // Primero se convierte del master lo que le falta a cada variante (Ajuste de Inventario)
      for (const c of planFull.conversiones) {
        const { data } = await axios.post(
          `${URL_INVENTARIOS}ConvertirDesdeMaster`,
          { articulos: c.articulo, areas: selectedArea, cantidad: c.falta, user: user.id },
          headersAuth
        );
        renglonesFull.forEach((a) => {
          if (String(a.articulos) === String(c.articulo)) a.idInv = data.idInv;
        });
        creados.push(
          `Del master: +${c.falta} ${c.SKU} (${data.tomado.map((t) => `${t.unidades} ${t.SKU}`).join(", ")}) · Ajuste ${data.ajuste}`
        );
      }

      if (renglonesFull.length > 0) {
        const ped = await crearPedidoDesdeRenglones(
          renglonesFull,
          selectedArea,
          true,
          { usarTotalesGlobales: grupoUnico, conComisiones: true }
        );
        creados.push(`Venta ${ped.idPedido || ""} (${renglonesFull.length} art.)`);
      }

      if (renglonesPedido.length > 0) {
        const ped = await crearPedidoDesdeRenglones(
          renglonesPedido,
          selectedAreaPedidos,
          false,
          {
            usarTotalesGlobales: grupoUnico,
            conComisiones: renglonesFull.length === 0,
          }
        );
        creados.push(`Pedido ${ped.idPedido || ""} (${renglonesPedido.length} art.)`);
      }

      await axios.post(
        URL_LOGS,
        {
          tipo: "Crear Pedido",
          detalle: `${selectedCliente} ${total_general} · ${creados.join(" + ")}`,
          user: user.id,
        },
        headersAuth
      );

      const aviso = Swal.fire({
        icon: enNegativo.length ? "warning" : "success",
        title: "Good job!",
        html:
          `Creado con éxito:<br>${creados.join("<br>")}` +
          (enNegativo.length
            ? `<p style="text-align:left;margin-top:12px"><b>Quedaron en negativo en el almacén (hay que ajustarlos) (${enNegativo.length}):</b><br>${enNegativo
                .slice(0, 30)
                .join("<br>")}${enNegativo.length > 30 ? "<br>..." : ""}</p>`
            : ""),
      });
      // Con negativos se espera al OK para que alcancen a copiar la lista
      if (enNegativo.length) aviso.then(() => window.location.reload());
      else setTimeout(() => window.location.reload(), 1500);
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response?.data || ""}`,
      });
      setValidaBoton(true);
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Faltan datos, favor de revisar",
    });
  }
};


  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: "",
        piezasPorCaja: 0,
        cajas: 0,
        cantidad: 0,
        precio: 0,
        precioBruto: 0,
        precioOriginal: 0,
        total: 0,
        articulosNombre: "",
        observacionesArticulo: "NA",
        idInv: "",
        costoUnitario: 0,
        cantInv: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let totalCan = values.map((c) => parseFloat(c.cantidad));
    let TC = totalCan.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let totalCajas = values.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(totTemp);
  };

  const handleChangeInputObservaciones = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.observacionesArticulo = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputPrecio = (value, name, id) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[name] = value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCajas = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.cajas = event.target.value;
        i.cantidad =
          parseFloat(event.target.value) * parseFloat(i.piezasPorCaja);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  const handleChangeInputCantidad = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        // Sin tope de inventario: la venta puede dejarlo en negativo
        i.cantidad = parseFloat(event.target.value);
        i.cajas = (
          parseFloat(event.target.value) / parseFloat(i.piezasPorCaja)
        ).toFixed(2);
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let totalKG = inputFields.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TK);
    let totalCajas = inputFields.map((c) => parseFloat(c.cajas));
    let TCajas = totalCajas.reduce((t, total, index) => t + total, 0);
    setTotalCajas(TCajas);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setSubTotal(TG);

    if (selectedImpuesto != 0) {
      setIva((selectedImpuesto * TG) / 100);
    } else {
      setIva(0);
    }
    let temp1 = (TG * descuento) / 100;

    setDescuentoNumero(temp1);

    let totTemp =
      (selectedImpuesto * TG) / 100 +
      TG +
      parseFloat(comisionTDC) +
      parseFloat(comisionFlete) -
      parseFloat(temp1);

    setTotalGeneral(totTemp);

    setSaldo(totTemp - efectivo - tdc - transfer);
  }


  function jalaCliente(cliente) {
    // setInputFields([
    //   {
    //     id: uuidv4(),
    //     articulos: "",
    //     piezasPorCaja: 0,
    //     cajas: 0,
    //     cantidad: 0,
    //     precio: 0,
    //     precioOriginal: 0,
    //     total: 0,
    //     articulosNombre: "",
    //     observacionesArticulo: "NA",
    //     idInv: "",
    //     costoUnitario:0
    //   },
    // ]);

    setSelectedCliente(cliente);

    axios
      .get(`${URL_CLIENTES}/${cliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCliente = res.data;
        setCliente(allCliente);
        // Todo lo de TikTok sale de CEDIS (el cliente esta ligado al almacen TikTok solo para reportes)
        if (
          String(allCliente.codigo || "").trim().toUpperCase() === "TIKTOK" ||
          (allCliente.areas || []).some((a) => String((a && a._id) || a) === AREAS_TIKTOK)
        ) {
          jalaArea(AREAS_CEDIS);
          jalaAreaPedidos(AREAS_CEDIS);
        }
        setSelectedColaborador(allCliente.vendedor[0]._id);
        setSelectedColaboradorName(
          allCliente.vendedor[0].nombre + " " + allCliente.vendedor[0].apellido
        );
        setDepartamentoCliente(allCliente.departamentosClientes[0]._id);
        // setCondPago(allCliente.forma_pago);
        // if(allCliente.forma_pago == "Credito"){
        //   setPago(false)
        // }else setPago(true)
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_SUCURSALES}/clientes/${cliente}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allSucursales = res.data;
        setSucursales(allSucursales);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function jalaSucursal(value) {
    let split = value.split(",");
    let dir = split[0];
    let paq = split[1];

    setSelectedSucursal(value);
    setSucursal(dir);
  }

  function calculaImpuesto(e) {
    setSelectedImpuesto(e);
    if (e != 0) {
      setIva((e * subTotal) / 100);
    } else {
      setIva(0);
    }

    setTotalGeneral(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete)
    );

    setSaldo(
      (e * subTotal) / 100 +
        subTotal +
        parseFloat(comisionTDC) +
        parseFloat(comisionFlete) -
        efectivo -
        tdc -
        transfer
    );
  }


  function autorizaCambio() {
    if (password == PASSWORD_CAMBIA_PRECIO) {
      setCambiarPrecio(true);
      toggleCambiaPrecio();
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "La contraseña es incorrecta!",
      });
    }
  }

  function jalaArea(e) {
    setSelectedArea(e);
    areas.map((a) => {
      if (a._id == e) {
        setSelectedAreaName(a.name);
      }
    });
  }

  function jalaAreaPedidos(e) {
    setSelectedAreaPedidos(e);
    areas.map((a) => {
      if (a._id == e) {
        setSelectedAreaPedidosName(a.name);
      }
    });
  }

  function importarArchivo(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los SKU de los artículos a sus objetos correspondientes
        const articulosMap = {};
        inventariosVenta.forEach((articulo) => {
          articulosMap[articulo.SKU] = articulo;
        });
        conCodigoOrigen(articulosMap, inventariosVenta);

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {

          const articulo = articulosMap[a.SKU];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              piezasPorCaja: 0,
              cajas: 0,
              precioOriginal: articulo.venta,
              articulosNombre: articulo.SKU,
              observacionesArticulo: "NA",
              idInv: articulo._id,
              costoUnitario: articulo.costoUnitario,
              cantInv: articulo.cantidad,

              cantidad: a.Unidades,
              precioBruto: a.PrecioBruto,
              precioBrutoSinIVA: Number((a.PrecioBruto * (1 - 0.16)).toFixed(2)),
              porcentajeComision: a.PorcentajeComision,
              comision: Number(((a.PrecioBruto * a.PorcentajeComision) / 100).toFixed(2)),
              costoFijo: a.CostoFijo,
              envio: a.Envio,
              retencionISR: Number((((a.PrecioBruto * (1 - 0.16)) * 2.5) / 100).toFixed(2)),
              retencionIVA: Number((((a.PrecioBruto * (1 - 0.16)) * 8) / 100).toFixed(2)),
              
              precio: Number(
                  (
                    a.PrecioBruto -
                    Number(((a.PrecioBruto * a.PorcentajeComision) / 100).toFixed(2)) -
                    Number(a.CostoFijo || 0) -
                    Number(a.Envio || 0) -
                    Number((((a.PrecioBruto * (1 - 0.16)) * 2.5) / 100).toFixed(2)) -
                    Number((((a.PrecioBruto * (1 - 0.16)) * 8) / 100).toFixed(2))
                  ).toFixed(2)
                ),

              total: Number(
                    (
                      Number(
                        (
                          a.PrecioBruto -
                          Number(((a.PrecioBruto * a.PorcentajeComision) / 100).toFixed(2)) -
                          Number(a.CostoFijo || 0) -
                          Number(a.Envio || 0) -
                          Number((((a.PrecioBruto * (1 - 0.16)) * 2.5) / 100).toFixed(2)) -
                          Number((((a.PrecioBruto * (1 - 0.16)) * 8) / 100).toFixed(2))
                        ).toFixed(2)
                      ) * Number(a.Unidades || 0)
                    ).toFixed(2)
                  ),
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.SKU);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes SKU no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }
// console.log("hola", inputFields)

  // ─── Importar reporte crudo MercadoLibre (para CEDIS + MELI) ─────────────
  // Layout: header en fila 6 (índice 5), 63 columnas, formato oficial de MeLi
  function importarArchivoMeliCEDIS(event) {
    const target = event.target;
    if (target.name !== "file" || !target.files[0]) return;

    const reader = new FileReader();
    reader.readAsArrayBuffer(target.files[0]);
    reader.onloadend = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = leerExcelNumerosLargos(data);
      // El reporte MeLi tiene 5 filas de header basura antes de la tabla real
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(sheet, { range: 5 });

      const articulosMap = {};
      inventariosVenta.forEach((art) => { articulosMap[art.SKU] = art; });
      conCodigoOrigen(articulosMap, inventariosVenta);
      const articulosMapPedidos = {};
      inventariosPedidosVenta.forEach((art) => { articulosMapPedidos[art.SKU] = art; });
      conCodigoOrigen(articulosMapPedidos, inventariosPedidosVenta);

      const noEncontrados = [];
      // Renglones de un archivo que ya se subio en esta captura (mismo # de venta y SKU)
      const yaEnCaptura = new Set(inputFields.map((a) => a.refMarketplace).filter(Boolean));
      const repetidos = [];
      let procesadas = 0;
      let procesadasFull = 0;
      let procesadasPedido = 0;
      let procesadasReventa = 0;
      let totalReporteML = 0;
      let totalCalculado = 0;
      // Lectura del reporte (solo lo que ML pago, articulos de paquete con su parte): reporteMeli.js
      const { renglones, noPagadas, enPaquete, colPrecio } = renglonesReporteMeli(rows);

      for (const v of renglones) {
        // Forma de entrega Full: se vende (descuenta inventario); cualquier otra (Colecta, Flex, etc.)
        // se queda como Pedido pendiente de surtir. Cada grupo sale de su propio almacen.
        const articulo = v.esFull ? articulosMap[v.sku] : articulosMapPedidos[v.sku];
        if (!articulo) {
          noEncontrados.push(`${v.sku} (${v.esFull ? "Full" : "Pedido"})`);
          continue;
        }

        const refMarketplace = v.venta ? `ML|${v.venta}|${v.sku}` : "";
        if (refMarketplace && yaEnCaptura.has(refMarketplace)) {
          repetidos.push(`#${v.venta}`);
          continue;
        }
        if (refMarketplace) yaEnCaptura.add(refMarketplace);

        totalReporteML += v.totalML;
        totalCalculado += v.total;

        inputFields.push({
          id: uuidv4(),
          articulos: articulo.idArticulo,
          piezasPorCaja: 0,
          cajas: 0,
          precioOriginal: articulo.venta,
          articulosNombre: articulo.SKU,
          observacionesArticulo: `MeLi ${v.esReventa ? "Reventa " : ""}#${v.venta} · ${v.comprador}`.substring(0, 100),
          refMarketplace,
          idInv: articulo._id,
          costoUnitario: articulo.costoUnitario,
          cantInv: articulo.cantidad,

          cantidad: v.unidades,
          precioBruto: v.precioBruto,
          precioBrutoSinIVA: v.precioSinIVA,
          porcentajeComision: v.porcentajeComision,
          comision: v.comision,
          costoFijo: 0,
          envio: v.envio,
          retencionISR: v.retencionISR,
          retencionIVA: v.retencionIVA,

          precio: v.precio,
          total: v.total,

          esFull: v.esFull,
          formaEntrega: v.formaEntrega,
        });
        procesadas++;
        if (v.esFull) procesadasFull++;
        else procesadasPedido++;
        if (v.esReventa) procesadasReventa++;
      }

      // Feedback
      const msgs = [
        `✅ ${procesadas} renglon(es) importados`,
        `📦 <b>${procesadasFull}</b> Full → se venden desde <b>${selectedAreaName}</b><br>📝 <b>${procesadasPedido}</b> no Full → quedan como Pedido desde <b>${selectedAreaPedidosName}</b>`,
      ];
      if (procesadasReventa) msgs.push(`🔁 ${procesadasReventa} de Reventa (ML compra): precio = lo que paga ML, sin comisión ni envío`);
      if (procesadas) {
        const fmt = (n) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
        msgs.push(`Neto importado <b>${fmt(totalCalculado)}</b> · Total de ML de esos renglones <b>${fmt(totalReporteML)}</b>`);
      }
      if (!colPrecio) msgs.push(`⚠️ No encontré la columna de precio unitario; se usó Ingresos por productos`);
      if (enPaquete) msgs.push(`📦 ${enPaquete} articulo(s) venian dentro de un paquete: tomaron la forma de entrega y su parte del monto del paquete`);
      if (noPagadas.length) msgs.push(`⚠️ ${noPagadas.length} renglon(es) que ML no pago (Total $0: canceladas, devueltas o reembolsadas) no se importan`);
      if (repetidos.length) msgs.push(`⚠️ ${repetidos.length} ventas ya estaban en esta captura (no se duplican): ${repetidos.slice(0, 15).join(", ")}`);
      if (noEncontrados.length) {
        msgs.push(`❌ ${noEncontrados.length} SKU sin match en su almacen:\n${noEncontrados.slice(0, 20).join(", ")}${noEncontrados.length > 20 ? "..." : ""}`);
      }
      Swal.fire({
        title: "Reporte MeLi procesado",
        html: msgs.join("<br><br>"),
        icon: noEncontrados.length ? "warning" : "success",
      });

      ActualizaTotales();
    };
  }

  // ======================= TikTok Shop =======================
  // Reporte "Pedidos" de TikTok Shop (exportacion de finanzas). Un renglon por
  // pedido+SKU. Se identifica el articulo por skuTikTok (ID de SKU de TikTok).
  const numTT = (v) => {
    const n = parseFloat(String(v == null ? "" : v).replace(/,/g, ""));
    return isNaN(n) ? 0 : n;
  };

  const mapaTikTok = (catalogo) => {
    const m = {};
    catalogo.forEach((a) => {
      String(a.skuTikTok || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean)
        .forEach((id) => (m[id] = a));
    });
    return m;
  };

  // Sugerencia para ligar: el articulo cuyo nombre/SKU comparte mas palabras
  const sugerirArticuloTikTok = (producto, variante) => {
    const palabras = (t) =>
      String(t || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .split(/[^a-z0-9]+/)
        // los numeros cuentan aunque sean cortos: distinguen "Pack 50" de "Set 15"
        .filter((w) => w.length > 2 || /^\d+$/.test(w));
    const buscadas = new Set(palabras(`${producto} ${variante}`));
    let mejor = null;
    let puntos = 0;
    articulosCatalogo
      .filter((a) => a.modelo !== "MASTER" && a.is_active !== "No")
      .forEach((a) => {
        const p = palabras(`${a.nombre} ${a.SKU}`).filter((w) => buscadas.has(w)).length;
        if (p > puntos) {
          puntos = p;
          mejor = a;
        }
      });
    return puntos >= 2 ? mejor : null;
  };

  async function importarArchivoTikTok(event) {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    event.target.value = ""; // permite volver a subir el mismo archivo

    const buf = await file.arrayBuffer();
    // IDs de SKU y de pedido exactos (son de 18-19 digitos y como numero se redondean)
    const wb = leerExcelNumerosLargos(new Uint8Array(buf));
    const sheet = wb.Sheets["Pedidos"] || wb.Sheets[wb.SheetNames[0]];
    const raw = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });

    // Export "Para enviar" de Seller Center (hoja OrderSKUList): se convierte al formato del de finanzas
    const porEnviar = filasTikTokPorEnviar(raw);
    if (porEnviar) {
      if (!porEnviar.length) {
        Swal.fire({ icon: "error", title: "Oops...", text: "El archivo de TikTok no trae pedidos." });
        return;
      }
      continuarTikTok(porEnviar);
      return;
    }

    // El encabezado real no esta en la primera fila: se busca
    const iHead = raw.findIndex((r) => String(r[0]).trim() === "ID del pedido");
    if (iHead < 0) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'No parece un reporte de TikTok Shop: sube el estado de cuenta (columna "ID del pedido") o el de pedidos "Para enviar" (columna "Order ID").',
      });
      return;
    }
    const head = raw[iHead].map((h) => String(h).trim());
    const obligatorias = [
      "ID del SKU",
      "Nombre del SKU",
      "Nombre del producto",
      "Ingresos por pedidos",
      "Costo de los pedidos",
      "Artículos vendidos",
      "Estado del pedido",
    ];
    const faltan = obligatorias.filter((c) => !head.includes(c));
    if (faltan.length) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Al reporte de TikTok le faltan columnas: ${faltan.join(", ")}`,
      });
      return;
    }

    const filas = raw
      .slice(iHead + 1)
      .filter((r) => String(r[0]).trim())
      .map((r) => {
        const o = {};
        head.forEach((h, i) => (o[h] = r[i]));
        return o;
      });
    continuarTikTok(filas);
  }

  // Export de pedidos de Seller Center ("Para enviar pedido-AAAA-MM-DD.xlsx", hoja OrderSKUList): encabezado
  // en ingles, segundo renglon con descripciones, montos "MXN 399.00". Regresa null si no es ese formato.
  // No trae comisiones ni envio de TikTok: el precio queda en el ingreso del vendedor (sin descuento de
  // TikTok, que lo paga TikTok) y neto = bruto hasta el estado de cuenta.
  function filasTikTokPorEnviar(raw) {
    const iHead = raw.findIndex((r) => r.map((h) => String(h).trim()).includes("Order ID") && r.map((h) => String(h).trim()).includes("SKU ID"));
    if (iHead < 0) return null;
    const head = raw[iHead].map((h) => String(h).trim());
    const v = (r, c) => r[head.indexOf(c)];
    const mxn = (x) => numTT(String(x == null ? "" : x).replace(/[^0-9.,-]/g, ""));
    return raw
      .slice(iHead + 1)
      // el renglon de descripciones y los vacios no traen un ID de pedido numerico
      .filter((r) => /^\d{10,}$/.test(String(v(r, "Order ID")).trim()))
      .map((r) => {
        const estado = String(v(r, "Order Status") || "").trim();
        const tipo = String(v(r, "Cancelation/Return Type") || "").trim();
        const sinPagar = !String(v(r, "Paid Time") || "").trim() || /sin pagar|unpaid|pendiente de pago/i.test(estado);
        const unidades = mxn(v(r, "Quantity")) - mxn(v(r, "Sku Quantity of return"));
        return {
          "ID del pedido": String(v(r, "Order ID")).trim(),
          "ID del SKU": String(v(r, "SKU ID")).trim(),
          "Nombre del producto": String(v(r, "Product Name") || "").trim(),
          "Nombre del SKU": [v(r, "Seller SKU"), v(r, "Variation")].map((x) => String(x || "").trim()).filter(Boolean).join(" · "),
          "Artículos vendidos": unidades,
          // cancelados y sin pagar no son venta
          "Estado del pedido": /cancel/i.test(estado) || /cancel/i.test(tipo) || sinPagar ? "Canceled" : estado,
          "Ingresos por pedidos": mxn(v(r, "SKU Subtotal Before Discount")) - mxn(v(r, "SKU Seller Discount")),
          "Costo de los pedidos": 0,
          porEnviar: true,
        };
      });
  }

  function continuarTikTok(filas) {
    // ID de TikTok que todavia no estan ligados a un articulo
    const mapa = mapaTikTok(articulosCatalogo);
    const sinLigar = {};
    filas.forEach((f) => {
      const id = String(f["ID del SKU"]).trim();
      if (!id || mapa[id] || String(f["Estado del pedido"]).toLowerCase() === "canceled") return;
      if (!sinLigar[id]) {
        sinLigar[id] = {
          id,
          producto: String(f["Nombre del producto"]).trim(),
          variante: String(f["Nombre del SKU"]).trim(),
          unidades: 0,
        };
      }
      sinLigar[id].unidades += numTT(f["Artículos vendidos"]);
    });

    const lista = Object.values(sinLigar).map((x) => {
      const sugerido = sugerirArticuloTikTok(x.producto, x.variante);
      return { ...x, articulo: sugerido, sugerido };
    });

    if (lista.length) {
      // Se pausa la importacion hasta ligarlos
      setTiktokPendiente({ filas, sinLigar: lista });
      return;
    }
    procesarTikTok(filas, mapa);
  }

  const guardarLigadoTikTok = async () => {
    const faltantes = tiktokPendiente.sinLigar.filter((x) => !x.articulo);
    if (faltantes.length) {
      Swal.fire({
        icon: "error",
        title: "Faltan productos por ligar",
        text: `Elige el artículo de: ${faltantes.map((x) => x.producto.slice(0, 40)).join(" / ")}`,
      });
      return;
    }
    setGuardandoTikTok(true);
    try {
      // Un articulo puede tener varios ID de TikTok (varias publicaciones)
      const porArticulo = {};
      tiktokPendiente.sinLigar.forEach((x) => {
        const k = x.articulo._id;
        if (!porArticulo[k]) porArticulo[k] = { art: x.articulo, ids: [] };
        porArticulo[k].ids.push(x.id);
      });
      const actualizados = { ...Object.fromEntries(articulosCatalogo.map((a) => [a._id, a])) };
      for (const { art, ids } of Object.values(porArticulo)) {
        const previos = String(art.skuTikTok || "").split(",").map((x) => x.trim()).filter(Boolean);
        const skuTikTok = [...new Set([...previos, ...ids])].join(",");
        await axios.patch(
          `${URL_ARTICULOS}/${art._id}`,
          { skuTikTok },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        actualizados[art._id] = { ...art, skuTikTok };
      }
      const nuevoCatalogo = Object.values(actualizados);
      setArticulosCatalogo(nuevoCatalogo);
      const filas = tiktokPendiente.filas;
      setTiktokPendiente(null);
      procesarTikTok(filas, mapaTikTok(nuevoCatalogo));
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo guardar el ligado con TikTok",
        footer: `${error.response?.data?.message || error.message || ""}`,
      });
    }
    setGuardandoTikTok(false);
  };

  function procesarTikTok(filas, mapa) {
    const cancelados = [];
    const reembolsados = [];
    const sinInventario = [];
    // Renglones de un archivo que ya se subio en esta captura (mismo pedido y SKU de TikTok)
    const yaEnCaptura = new Set(inputFields.map((a) => a.refMarketplace).filter(Boolean));
    const repetidos = [];
    let procesadas = 0;
    let unidadesTot = 0;

    for (const f of filas) {
      const estado = String(f["Estado del pedido"]).trim();
      const pedido = String(f["ID del pedido"]).trim();
      if (estado.toLowerCase() === "canceled") {
        cancelados.push(pedido);
        continue;
      }

      const unidades = numTT(f["Artículos vendidos"]);
      const ingresos = numTT(f["Ingresos por pedidos"]); // ya trae el descuento del vendedor
      if (unidades <= 0) continue;
      if (ingresos <= 0) {
        // Reembolsado/devuelto: no hay venta que registrar
        reembolsados.push(pedido);
        continue;
      }

      const idSku = String(f["ID del SKU"]).trim();
      const refMarketplace = `TT|${pedido}|${idSku}`;
      if (yaEnCaptura.has(refMarketplace)) {
        repetidos.push(pedido);
        continue;
      }

      const art = mapa[idSku];
      // Las ventas de TikTok se guardan como pedido pendiente de surtir desde CEDIS (almacen de
      // pedidos) y se surten desde Pendiente Surtir; no descuentan inventario al guardar
      const inv = art
        ? inventariosPedidosVenta.find((i) => String(i.idArticulo) === String(art._id) && !i.esMaster)
        : null;
      if (!inv) {
        sinInventario.push(`${art ? art.SKU : idSku}`);
        continue;
      }

      // Todo lo que TikTok le cobra al vendedor viene en "Costo de los pedidos".
      // Se separa en impuestos, envio y comisiones; lo que no es impuesto ni envio
      // es comision (asi una tarifa nueva de TikTok cae sola en comision).
      const costo = -numTT(f["Costo de los pedidos"]);
      const isr = -(numTT(f["ISR"]) + numTT(f["Impuesto cedular"]));
      const iva = -numTT(f["IVA"]);
      const envio = -(
        numTT(f["TikTok Shop cubre el costo de envío"]) +
        numTT(f["Tarifa de envío del cliente"]) +
        numTT(f["Tarifa de envío reembolsada del cliente"]) +
        numTT(f["Costo de envío de devoluciones"]) +
        numTT(f["Costo de envío"])
      );
      const comision = costo - isr - iva - envio;

      const r2 = (v) => Number(v.toFixed(2));
      const precioBruto = r2(ingresos / unidades);
      const comisionU = r2(comision / unidades);
      const envioU = r2(envio / unidades);
      const isrU = r2(isr / unidades);
      const ivaU = r2(iva / unidades);
      const precioNeto = r2(precioBruto - comisionU - envioU - isrU - ivaU);

      inputFields.push({
        id: uuidv4(),
        articulos: inv.idArticulo,
        piezasPorCaja: 0,
        cajas: 0,
        precioOriginal: inv.venta,
        articulosNombre: inv.SKU,
        observacionesArticulo: `TikTok #${pedido} · ${f["Nombre del SKU"] || ""}`.substring(0, 100),
        refMarketplace,
        // "Para enviar" no trae comisiones: queda pendiente de subir el estado de cuenta en Pedidos
        edoCtaTikTok: f.porEnviar ? "No" : "Si",
        idInv: inv._id,
        costoUnitario: inv.costoUnitario,
        cantInv: inv.cantidad,

        cantidad: unidades,
        precioBruto,
        precioBrutoSinIVA: r2(precioBruto / 1.16),
        porcentajeComision: precioBruto > 0 ? r2((comisionU / precioBruto) * 100) : 0,
        comision: comisionU,
        costoFijo: 0,
        envio: envioU,
        retencionISR: isrU,
        retencionIVA: ivaU,

        precio: precioNeto,
        total: r2(precioNeto * unidades),

        esFull: false,
        formaEntrega: "TikTok",
      });
      procesadas++;
      unidadesTot += unidades;
    }

    const msgs = [`✅ ${procesadas} renglon(es) de TikTok importados · ${unidadesTot} unidades · se guardan como <b>pedido pendiente de surtir</b> desde <b>${selectedAreaPedidosName || "Cedis Toluca"}</b>`];
    if (cancelados.length) msgs.push(`⚠️ ${cancelados.length} pedidos cancelados (no se registran)`);
    if (reembolsados.length) msgs.push(`⚠️ ${reembolsados.length} pedidos reembolsados o sin ingreso (no se registran)`);
    if (repetidos.length) msgs.push(`⚠️ ${repetidos.length} renglones ya estaban en esta captura (no se duplican)`);
    if (filas.some((f) => f.porEnviar))
      msgs.push("ℹ️ Archivo de pedidos <b>Para enviar</b>: no trae comisiones ni envío de TikTok, el precio va al <b>ingreso bruto</b> (neto = bruto). Al guardar se omiten los pedidos que ya estén registrados. Las comisiones se descuentan después subiendo el <b>estado de cuenta de TikTok</b> en el listado de Pedidos.");
    if (sinInventario.length) {
      const unicos = [...new Set(sinInventario)];
      msgs.push(`❌ ${sinInventario.length} renglones sin variante en el catálogo (SKU sin ligar o master): ${unicos.slice(0, 15).join(", ")}`);
    }
    Swal.fire({
      title: "Reporte TikTok procesado",
      html: msgs.join("<br><br>"),
      icon: sinInventario.length ? "warning" : "success",
    });
    ActualizaTotales();
  }

  function importarArchivoAmazon(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let hojas = [];

    if (name === "file") {
      let reader = new FileReader();
      reader.readAsArrayBuffer(target.files[0]);
      reader.onloadend = (e) => {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, { type: "array" });

        workbook.SheetNames.forEach(function (sheetName) {
          // Here is your object
          var XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          hojas.push({
            data: XL_row_object,
            sheetName,
          });
        });

        let A1 = hojas[0].data;

        // Crear un objeto que mapee los ASIN de los artículos a sus objetos correspondientes
        const articulosMap = {};
        inventariosVenta.forEach((articulo) => {
          articulosMap[articulo.ASIN] = articulo;
        });

        const articulosNoEncontrados = [];

        // Iterar sobre A1 una sola vez
        for (const a of A1) {

          const articulo = articulosMap[a.ASIN];
          if (articulo) {
            inputFields.push({
              id: uuidv4(),
              articulos: articulo.idArticulo,
              piezasPorCaja: 0,
              cajas: 0,
              precioOriginal: articulo.venta,
              articulosNombre: articulo.ASIN,
              observacionesArticulo: "NA",
              idInv: articulo._id,
              costoUnitario: articulo.costoUnitario,
              cantInv: articulo.cantidad,

              cantidad: a.Unidades,
              precioBruto: a.PrecioBruto,
              precioBrutoSinIVA: Number((a.PrecioBruto * (1 - 0.16)).toFixed(2)),
              porcentajeComision: a.PorcentajeComision,
              comision: Number(((a.PrecioBruto * a.PorcentajeComision) / 100).toFixed(2)),
              costoFijo: a.CostoFijo,
              envio: a.Envio,
              retencionISR: Number((((a.PrecioBruto * (1 - 0.16)) * 2.5) / 100).toFixed(2)),
              retencionIVA: Number((((a.PrecioBruto * (1 - 0.16)) * 8) / 100).toFixed(2)),
              
              precio: Number(
                  (
                    a.PrecioBruto -
                    Number(((a.PrecioBruto * a.PorcentajeComision) / 100).toFixed(2)) -
                    Number(a.CostoFijo || 0) -
                    Number(a.Envio || 0) -
                    Number((((a.PrecioBruto * (1 - 0.16)) * 2.5) / 100).toFixed(2)) -
                    Number((((a.PrecioBruto * (1 - 0.16)) * 8) / 100).toFixed(2))
                  ).toFixed(2)
                ),

              total: Number(
                    (
                      Number(
                        (
                          a.PrecioBruto -
                          Number(((a.PrecioBruto * a.PorcentajeComision) / 100).toFixed(2)) -
                          Number(a.CostoFijo || 0) -
                          Number(a.Envio || 0) -
                          Number((((a.PrecioBruto * (1 - 0.16)) * 2.5) / 100).toFixed(2)) -
                          Number((((a.PrecioBruto * (1 - 0.16)) * 8) / 100).toFixed(2))
                        ).toFixed(2)
                      ) * Number(a.Unidades || 0)
                    ).toFixed(2)
                  ),
            });
          } else {
            // Si no se encuentra el artículo, agregarlo a la lista de no encontrados
              articulosNoEncontrados.push(a.ASIN);
          }
        }

        // Verificar si se encontraron artículos que no estaban en el mapa
        if (articulosNoEncontrados.length > 0) {
          const mensaje = `Los siguientes ASIN no se encontraron: ${articulosNoEncontrados.join(
            ", "
          )}`;
          Swal.fire({
            title: "Artículos no encontrados",
            text: mensaje,
            icon: "warning",
            button: "Entendido",
          });
        }

        ActualizaTotales();
      };
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Venta Directa</h3>
          {/* <Form > */}
          <Row>
            <Col md={2}>
              <Label>Fecha</Label>
              <Input
                type="date"
                placeholder="Fecha"
                value={fecha}
                required
                // disabled
                onChange={(e) => {
                  setFecha(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label className="mr-sm-2">Cliente</Label>
              <Input
                className="col-sm-12"
                type="select"
                value={selectedCliente}
                required
                onChange={(e) => {
                  jalaCliente(e.target.value);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Sucursal</Label>
              <Input
                type="select"
                value={selectedSucursal}
                onChange={(e) => {
                  jalaSucursal(e.target.value);
                }}
              >
                <option value="">Selecciona una Sucursal</option>
                {sucursales
                  .sort((a, b) => (a.alias > b.alias ? 1 : -1))
                  .map((a) => {
                    if (a.is_active == "Si") {
                      return <option value={[a._id]}>{a.alias}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Vendedor</Label>
              <Input
                type="select"
                value={selectedColaborador}
                // onChange={(e) => {
                //   setSelectedColaborador(e.target.value)
                // }}
                disabled
              >
                <option value="">Selecciona un Vendedor</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                  })}
              </Input>
            </Col>

            {/* <Col md={1}>
              <Label>Paqueteria</Label>
              <Input
                type="text"
                placeholder="Paqueteria"
                value={paqueteria}
                required
                onChange={(e) => {
                  setPaqueteria(e.target.value);
                }}
              />
            </Col> */}
          </Row>
          <Row>
            <Col md={2}>
              <Label>Surtir de Almacen (Full / venta)</Label>
              <Input
                type="select"
                value={selectedArea}
                onChange={(e) => {
                  jalaArea(e.target.value);
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (
                      a._id == AREAS_CEDIS ||
                      a._id == AREAS_AMAZON ||
                      a._id == AREAS_AMAZON_YOU ||
                      a._id == AREAS_APARTADO ||
                      a._id == AREAS_MELI ||
                      a._id == AREAS_MELI_NOVA ||
                      a._id == AREAS_WALMART ||
                      a._id == AREAS_WALMART_NOVA ||
                      a._id == AREAS_WALMART_DROP ||
                      a._id == AREAS_WALMART_NOVA_DROP ||
                      a._id == AREAS_COPPEL ||
                      a._id == AREAS_COPPEL_NOVA ||
                      a._id == AREAS_COPPEL_DROP ||
                      a._id == AREAS_COPPEL_NOVA_DROP
                    ) {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Surtir de Almacen (no Full → Pedido)</Label>
              <Input
                type="select"
                value={selectedAreaPedidos}
                onChange={(e) => {
                  jalaAreaPedidos(e.target.value);
                }}
              >
                <option value="">Selecciona un almacen</option>
                {areas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (
                      a._id == AREAS_CEDIS ||
                      a._id == AREAS_AMAZON ||
                      a._id == AREAS_AMAZON_YOU ||
                      a._id == AREAS_APARTADO ||
                      a._id == AREAS_MELI ||
                      a._id == AREAS_MELI_NOVA ||
                      a._id == AREAS_WALMART ||
                      a._id == AREAS_WALMART_NOVA ||
                      a._id == AREAS_WALMART_DROP ||
                      a._id == AREAS_WALMART_NOVA_DROP ||
                      a._id == AREAS_COPPEL ||
                      a._id == AREAS_COPPEL_NOVA ||
                      a._id == AREAS_COPPEL_DROP ||
                      a._id == AREAS_COPPEL_NOVA_DROP
                    ) {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            {/* <Col md={1}>
              <Label>Comision TDC</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionTDC}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionTDC(value);
                }}
              />
            </Col>
            <Col md={1}>
              <Label>Flete</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={comisionFlete}
                className={`form-control`}
                onValueChange={(value) => {
                  jalaComisionFlete(value);
                }}
              />
            </Col> */}

            {/* <Col md={1}>
              <Label>Descuento %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuento}
                onChange={(e) => {
                  calculaDescuento(e.target.value);
                }}
              />
            </Col> */}

            <Col md={1}>
              <Label>Impuestos %</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={selectedImpuesto}
                onChange={(e) => {
                  calculaImpuesto(e.target.value);
                }}
              />
            </Col>

            <Col md={1}>
              <Label>Sub Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={subTotal}
                disabled
                className={`form-control`}
              />
            </Col>
            <Col md={1}>
              <Label>IVA</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={iva}
                disabled
                className={`form-control`}
              />
            </Col>
            {/* <Col md={1}>
              <Label>Descuento $</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={descuentoNumero}
                disabled
              />
            </Col> */}
            <Col md={1}>
              <Label>Total</Label>
              <CurrencyInput
                intlConfig={{ locale: "en-US", currency: "USD" }}
                prefix="$"
                placeholder="Ingresa una cantidad"
                defaultValue={0}
                decimalsLimit={2}
                value={total_general}
                disabled
                className={`form-control`}
              />
            </Col>

            <Col md={1}>
              <Label>Piezas</Label>
              <Input
                type="number"
                min="0"
                step="any"
                placeholder="Piezas"
                value={total_cantidad}
                required
                disabled
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label for="exampleEmail" className="mr-sm-2">
                Observaciones
              </Label>
              <Input
                type="textarea"
                placeholder="Observaciones"
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
            {/* <Col md={1}>
              <Label>Cambio de Precio</Label>
              <Button
                size="sm"
                className="btn"
                color="info"
                onClick={(e) => toggleCambiaPrecio()}
              >
                Solicitar
              </Button>
            </Col> */}
          </Row>
          <br />
          <Row>
            {(() => {
              const faltantes = [];
              if (!selectedCliente) faltantes.push("Cliente");
              if (!selectedSucursal || (Array.isArray(selectedSucursal) && selectedSucursal.length === 0)) faltantes.push("Sucursal");
              if (!selectedColaborador) faltantes.push("Vendedor");
              const bloqueado = faltantes.length > 0;
              const avisoBloqueado = bloqueado ? (
                <Col md={12} style={{ marginBottom: 8 }}>
                  <div style={{ background: "#fef3c7", border: "1px solid #fcd34d", padding: "10px 14px", borderRadius: 8, color: "#92400e", fontSize: "0.85rem" }}>
                    <i className="fas fa-exclamation-triangle" style={{ marginRight: 8 }}></i>
                    Selecciona <strong>{faltantes.join(", ")}</strong> antes de subir el archivo.
                  </div>
                </Col>
              ) : null;

              return (
                <>
                  {avisoBloqueado}
                  {selectedArea == AREAS_APARTADO ||
                  selectedArea == AREAS_CEDIS ||
                  selectedArea == AREAS_MELI ||
                  selectedArea == AREAS_MELI_NOVA ||
                  selectedArea == AREAS_WALMART ||
                  selectedArea == AREAS_WALMART_NOVA ||
                  selectedArea == AREAS_WALMART_DROP ||
                  selectedArea == AREAS_WALMART_NOVA_DROP ||
                  selectedArea == AREAS_COPPEL ||
                  selectedArea == AREAS_COPPEL_NOVA ||
                  selectedArea == AREAS_COPPEL_DROP ||
                  selectedArea == AREAS_COPPEL_NOVA_DROP ? (
                    <Col md={3}>
                      <Input
                        required
                        type="file"
                        name="file"
                        id="file"
                        onChange={(event) => importarArchivo(event)}
                        disabled={bloqueado}
                      />
                      <small style={{ color: "#64748b", fontSize: "0.7rem" }}>Formato interno (SKU/PrecioBruto)</small>
                    </Col>
                  ) : selectedArea == AREAS_AMAZON ||
                     selectedArea == AREAS_AMAZON_YOU ? (
                    <Col md={3}>
                      <Input
                        required
                        type="file"
                        name="file"
                        id="file"
                        onChange={(event) => importarArchivoAmazon(event)}
                        disabled={bloqueado}
                      />
                    </Col>
                  ) : undefined}

                  {/* Subir reporte crudo de MercadoLibre — solo cuando el destino es MELI (CEDIS surtiendo) */}
                  {(selectedArea == AREAS_MELI || selectedArea == AREAS_MELI_NOVA || selectedArea == AREAS_CEDIS) && (
                    <Col md={3}>
                      <Input
                        type="file"
                        name="file"
                        id="fileMeli"
                        onChange={(event) => importarArchivoMeliCEDIS(event)}
                        disabled={bloqueado}
                      />
                      <small style={{ color: "#059669", fontSize: "0.7rem", fontWeight: 600 }}>
                        📥 Reporte oficial MeLi (formato crudo)
                      </small>
                    </Col>
                  )}

                  {/* Reporte de pedidos de TikTok Shop — todo lo de TikTok sale de CEDIS */}
                  {selectedArea == AREAS_CEDIS && (
                    <Col md={3}>
                      <Input
                        type="file"
                        name="fileTikTok"
                        id="fileTikTok"
                        accept=".xlsx,.xls"
                        onChange={(event) => importarArchivoTikTok(event)}
                        disabled={bloqueado}
                      />
                      <small style={{ color: "#db2777", fontSize: "0.7rem", fontWeight: 600 }}>
                        🎵 Reporte de pedidos TikTok Shop
                      </small>
                    </Col>
                  )}
                </>
              );
            })()}
          </Row>

          {/* Tabla Articulos */}

          {/* <Form className={classes.root}> */}


          
{(() => {
  const fmt = (v) => new Intl.NumberFormat("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(v) || 0);
  const numTd = { textAlign: "right", padding: "6px 10px", fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" };
  const skuTd = { padding: "6px 10px", fontWeight: 600, whiteSpace: "nowrap" };
  const headTd = { padding: "8px 10px", fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: "0.03em", color: "#64748b", background: "#f1f5f9", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const headNum = { ...headTd, textAlign: "right" };
  return (
    <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: 10 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.78rem" }}>
        <thead>
          <tr>
            <th style={headTd}>SKU</th>
            <th style={{ ...headTd, textAlign: "center" }}>Tipo</th>
            <th style={headNum}>Unid</th>
            <th style={headNum}>$ Bruto</th>
            <th style={headNum}>Bruto s/IVA</th>
            <th style={headNum}>% Com</th>
            <th style={headNum}>Comisión</th>
            <th style={headNum}>Envío</th>
            <th style={headNum}>Ret ISR</th>
            <th style={headNum}>Ret IVA</th>
            <th style={headNum}>Total Ret</th>
            <th style={headNum}>$ Neto</th>
            <th style={headNum}>Total</th>
            <th style={{ ...headTd, textAlign: "center", width: 40 }}></th>
          </tr>
        </thead>
        <tbody>
          {inputFields.map((f, idx) => {
            const sku = (f?.articulosNombre || "").split(" ")[0] || "";
            const unidades = Number(f?.cantidad || 0);
            const precioBruto = Number(f?.precioBruto || 0);
            const envio = Number(f?.envio || 0);
            const comision = Number(f?.comision || 0);
            const retISR = Number(f?.retencionISR || 0);
            const retIVA = Number(f?.retencionIVA || 0);
            const totalRetenido = Number((comision + retISR + retIVA).toFixed(2));
            const precioNeto = Number(f?.precio || 0);
            const total = Number((precioNeto * unidades).toFixed(2));
            const excedido = articulosExcedidos.has(claveGrupo(f));
            const delMaster = articulosDelMaster.has(claveGrupo(f));
            const rowStyle = {
              background: excedido ? "#fee2e2" : delMaster ? "#ffedd5" : idx % 2 === 0 ? "#fff" : "#fafbfc",
              borderBottom: "1px solid #f1f5f9",
            };
            return (
              <tr key={f.id} style={rowStyle}>
                <td style={skuTd}>
                  {sku}
                  {excedido && (
                    <span
                      title="No alcanza el inventario (ni con el master): se vende y el almacén queda en negativo"
                      style={{ marginLeft: 6, fontSize: "0.6rem", fontWeight: 700, color: "#991b1b", background: "#fecaca", padding: "1px 5px", borderRadius: 4 }}
                    >
                      queda en negativo
                    </span>
                  )}
                  {delMaster && (
                    <span
                      title="La variante no alcanza: al guardar se convierte del inventario del master"
                      style={{ marginLeft: 6, fontSize: "0.6rem", fontWeight: 700, color: "#9a3412", background: "#fed7aa", padding: "1px 5px", borderRadius: 4 }}
                    >
                      del master
                    </span>
                  )}
                </td>
                <td style={{ textAlign: "center", padding: "6px 10px" }}>
                  <span
                    title={f?.formaEntrega || ""}
                    style={{
                      fontSize: "0.65rem",
                      fontWeight: 700,
                      padding: "2px 6px",
                      borderRadius: 4,
                      whiteSpace: "nowrap",
                      color: esFullRenglon(f) ? "#065f46" : "#9a3412",
                      background: esFullRenglon(f) ? "#d1fae5" : "#ffedd5",
                    }}
                  >
                    {!esFullRenglon(f) ? "PEDIDO" : f.esFull === true ? "FULL" : "VENTA"}
                  </span>
                </td>
                <td style={numTd}>{unidades}</td>
                <td style={numTd}>${fmt(precioBruto)}</td>
                <td style={numTd}>${fmt(f?.precioBrutoSinIVA)}</td>
                <td style={numTd}>{fmt(f?.porcentajeComision)}%</td>
                <td style={{ ...numTd, color: "#dc2626" }}>-${fmt(comision)}</td>
                <td style={{ ...numTd, color: "#dc2626" }}>-${fmt(envio)}</td>
                <td style={{ ...numTd, color: "#dc2626" }}>-${fmt(retISR)}</td>
                <td style={{ ...numTd, color: "#dc2626" }}>-${fmt(retIVA)}</td>
                <td style={{ ...numTd, color: "#dc2626", fontWeight: 600 }}>-${fmt(totalRetenido)}</td>
                <td style={{ ...numTd, color: "#059669", fontWeight: 600 }}>${fmt(precioNeto)}</td>
                <td style={{ ...numTd, fontWeight: 700, color: "#0f172a" }}>${fmt(total)}</td>
                <td style={{ textAlign: "center", padding: "4px" }}>
                  <Button
                    size="sm"
                    color="danger"
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(f.id)}
                    tabIndex="-1"
                    style={{ padding: "2px 8px", fontSize: "0.75rem" }}
                  >
                    <i className="fas fa-minus"></i>
                  </Button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
})()}






          <br />
          {/* <Row>
            <Col md={5}></Col>
            <Col md={1}>
            <Label>Total Cajas</Label>
                  <Input
                type="number"
                min="0"
                step="any"
                placeholder="Cajas"
                value={total_cajas}
                disabled
              /></Col>
          </Row> */}
          <Row>
            {/* </Row> */}
            <br />
            {/* <Col md={3}>
              <Input
                type="checkbox"
                onChange={(event) => setPago(event.currentTarget.checked)}
                checked={pago}
              />

              <h4 className="subMenuTitulo">Deseas Pagar la Nota?</h4>
              </Col> */}
          </Row>
          {/* </Form> */}
          {/* Termina Tabla Articulos */}
          <br />
          <Row>
            <Col md={3}>
              {validaBoton ? (
                <Button
                  type="submit"
                  className="btn btn-success"
                  tabindex="-1"
                  onClick={savePedido}
                >
                  Guardar
                </Button>
              ) : (
                <Button type="submit" className="btn btn-success" disabled>
                  Guardar
                </Button>
              )}
              {/* </Col>
            <Col md={1}> */}
              <Button
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
          </Row>
          {/* </Form> */}
          <br />
          <Modal size="xl" isOpen={!!tiktokPendiente} toggle={() => setTiktokPendiente(null)}>
            <ModalHeader toggle={() => setTiktokPendiente(null)}>
              Ligar productos de TikTok
            </ModalHeader>
            <ModalBody>
              <p style={{ fontSize: "0.85rem", color: "#475569" }}>
                El reporte de TikTok no trae tu SKU, solo el ID de TikTok. Elige a
                qué artículo corresponde cada uno; se guarda en el artículo y la
                próxima vez se cruza solo. Las sugerencias salen por parecido de
                nombre y pueden estar mal: revísalas.
              </p>
              <Table size="sm" borderless>
                <thead>
                  <tr>
                    <th style={{ width: "40%" }}>Producto en TikTok</th>
                    <th style={{ width: "8%", textAlign: "right" }}>Unid.</th>
                    <th>Artículo en Tydart</th>
                  </tr>
                </thead>
                <tbody>
                  {(tiktokPendiente ? tiktokPendiente.sinLigar : []).map((x, i) => (
                    <tr key={x.id}>
                      <td style={{ fontSize: "0.8rem" }}>
                        <b>{x.producto}</b>
                        <br />
                        <span style={{ color: "#64748b" }}>
                          {x.variante} · ID {x.id}
                        </span>
                      </td>
                      <td style={{ textAlign: "right" }}>{x.unidades}</td>
                      <td>
                        <Autocomplete
                          size="small"
                          value={x.articulo}
                          onChange={(event, sel) => {
                            const sinLigar = [...tiktokPendiente.sinLigar];
                            sinLigar[i] = { ...x, articulo: sel };
                            setTiktokPendiente({ ...tiktokPendiente, sinLigar });
                          }}
                          options={articulosCatalogo.filter(
                            (a) => a.modelo !== "MASTER" && a.is_active !== "No"
                          )}
                          getOptionLabel={(a) => (a ? `${a.SKU} ${a.nombre || ""}` : "")}
                          getOptionSelected={(a, b) => a._id === b._id}
                          renderInput={(params) => (
                            <TextField {...params} label="Selecciona" variant="outlined" />
                          )}
                        />
                        {x.articulo && x.sugerido && x.articulo._id === x.sugerido._id ? (
                          <small style={{ color: "#b45309", fontWeight: 600 }}>
                            Sugerido por nombre — revísalo antes de guardar
                          </small>
                        ) : undefined}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ModalBody>
            <ModalFooter>
              <Button color="success" onClick={guardarLigadoTikTok} disabled={guardandoTikTok}>
                Guardar y continuar
              </Button>
              <Button color="secondary" onClick={() => setTiktokPendiente(null)}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
          <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Cortesia</h4>
            </ModalHeader>
            <ModalBody>
              <Input
                bsSize="sm"
                type="password"
                placeholder="Password"
                value={password}
                required
                onChange={(event) => setPassword(event.target.value)}
              />
              <br />
              <Row>
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => autorizaCambio()}
                  >
                    Autorizar
                  </Button>
                </Col>
              </Row>
            </ModalBody>
          </Modal>

          {/* <Modal
            size="sm"
            isOpen={modalCambiaPrecio}
            toggle={toggleCambiaPrecio}
          >
            <ModalHeader toggle={toggleCambiaPrecio}>
              <h4>Autorizar Precio</h4>
            </ModalHeader>
            <ModalBody>
              {mailAutEnviado == false ? (
                <Col>
                  <Button
                    type="submit"
                    className="btn btn-success"
                    onClick={(e) => solicitarAut()}
                  >
                    Solicitar Autorizacion
                  </Button>
                </Col>
              ) : (
                <>
                  <Input
                    bsSize="sm"
                    type="password"
                    placeholder="Password"
                    value={password}
                    required
                    onChange={(event) => setPassword(event.target.value)}
                  />
                  <br />
                  <Row>
                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => autorizaCambio()}
                      >
                        Autorizar
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="submit"
                        className="btn btn-success"
                        onClick={(e) => solicitarAut()}
                      >
                        Reenviar Solicitud
                      </Button>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal> */}
        </div>
      ) : undefined}
    </>
  );
}

export default VentaDirectaArchivoCreate;
